import {constant} from 'lodash/fp';

import {FETCH_LOGGED_IN_USER} from '/enum/launchSequence.enum';
import {getInfo} from '/redux/action/currentUser.action';
import {completedStepByName} from '/redux/selector/launchSequence.selector';
import {getAccessToken} from '/util/fetch.util';
import {withProps} from '/util/selector.util';

const fetchLoggedInUserTask = {
  stepName: FETCH_LOGGED_IN_USER,

  isCompleted: ({state}: any) =>
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    withProps({stepName: FETCH_LOGGED_IN_USER})(completedStepByName)(state),

  perform: async ({dispatch}: any) => {
    const token = await getAccessToken();

    if (token) {
      // Don't do anything if the "fetch current user info during app startup" operation
      // is unsuccessful because that probably just means that the user isn't already
      // signed in.
      return dispatch(getInfo({trackLoginEvent: false})).catch(
        constant(undefined),
      );
    }
    return Promise.resolve(); // safely skip
  },
};

export default fetchLoggedInUserTask;
